import { HotspotPin } from "@vericus/cadmus-icons";
import { colors, Divider, Text } from "@vericus/cadmus-ui";

import { QuestionFieldFragment } from "@/generated/graphql";

import { useHotspotPositionObjectResponseForm } from "./hooks";
import {
  CanvasWrapper,
  OptionButton,
  OptionButtonText,
  OptionDividerWrapper,
  OptionsList,
  QuestionWrapper,
  TipContainer,
} from "./hotspot-position-object-response-form.styles";
import { HotspotQuestionNote } from "../constants";

interface HotspotPositionObjectResponseFormProps {
  answerBlockId: string;
  questionFields: QuestionFieldFragment[];
  isReadonly?: boolean;
}

const HotspotPositionObjectResponseForm: React.FC<
  HotspotPositionObjectResponseFormProps
> = ({ answerBlockId, questionFields, isReadonly = false }) => {
  const {
    canvasRef,
    wrapperRef,
    promptImage,
    optionsNotOnCanvas,
    isHoveringPin,
    currentFieldIdentifier,
    setCurrentFieldIdentifier,
    handleCanvasClick,
    handleMouseMove,
  } = useHotspotPositionObjectResponseForm(
    answerBlockId,
    questionFields,
    isReadonly
  );

  return (
    <QuestionWrapper>
      <TipContainer>
        <Text kind="bodyMd" color="navy500">
          {HotspotQuestionNote.PositionObjectInteraction}
        </Text>
      </TipContainer>
      <CanvasWrapper
        hasWiderImage={
          !!promptImage && (promptImage.width || 0) > (promptImage.height || 0)
        }
        ref={wrapperRef}
        isHoveringPin={isHoveringPin}
        showPin={!!currentFieldIdentifier}
      >
        {promptImage?.url && (
          <canvas
            ref={canvasRef}
            onClick={handleCanvasClick}
            onMouseMove={handleMouseMove}
          />
        )}
      </CanvasWrapper>
      {!!optionsNotOnCanvas.length && (
        <>
          <OptionDividerWrapper>
            Options
            <Divider style={{ width: "100%" }} />
          </OptionDividerWrapper>
          <OptionsList>
            {optionsNotOnCanvas.map((option) => (
              <OptionButton
                key={option.fieldIdentifier}
                onClick={() => {
                  setCurrentFieldIdentifier(option.fieldIdentifier);
                }}
              >
                <OptionButtonText
                  selected={currentFieldIdentifier === option.fieldIdentifier}
                  kind="bodyMd"
                >
                  {option.label}
                </OptionButtonText>
                <HotspotPin
                  label="Hotspot pin icon"
                  color={colors.primary}
                  size={20}
                />
              </OptionButton>
            ))}
          </OptionsList>
        </>
      )}
    </QuestionWrapper>
  );
};

export default HotspotPositionObjectResponseForm;
